@if (label(); as label) {
  <label class="text-xs font-medium text-foreground-primary-60">
    {{ label }}
    @if (isRequired()) {
      <span class="text-status-error">*</span>
    }
  </label>
}
<mat-datepicker
  #picker
  [disabled]="isDisabled"
  [title]="label()"
  [onlyView]="onlyView"
  [optional]="optional"
  [selectEndOfPeriod]="selectEndOfPeriod"
>
  @if (isAction) {
    <mat-datepicker-actions></mat-datepicker-actions>
  }
</mat-datepicker>

<div class="min-w-0 flex flex-col">
  <div class="min-w-0 flex relative" (click)="!allowFreeText && picker.open()">
    <div
      class="min-w-0 grow flex flex-col"
      [class.cursor-pointer]="!isDisabled && !allowFreeText"
      [class.cursor-default]="isDisabled && !allowFreeText"
    >
      <input
        [matDatepicker]="picker"
        type="text"
        autocomplete="off"
        [placeholder]="placeHolder"
        [(ngModel)]="value"
        [disabled]="isDisabled || !allowFreeText"
        [min]="minimumDate"
        [max]="maximumDate"
        [withTime]="withTime"
        [onlyView]="onlyView"
        class="rounded-radius-container font-semibold text-sm text-action-primary placeholder:text-action-primary whitespace-nowrap bg-background-fixed px-[44px] border"
        [class.pointer-events-none]="!allowFreeText"
        [ngClass]="[
          inputClasses(),
          size === 'large' ? 'h-[45px]' : 'h-[36px]',
          error() || isValid === false ? 'border-status-error' : 'border-[transparent]',
          isDisabled
            ? 'placeholder:[&&&]:text-custom-disabled-input-color [&&&]:text-custom-disabled-input-color [&&&&]:bg-custom-disabled-input-background'
            : '',
        ]"
        [class.cursor-pointer]="!isDisabled"
        [class.cursor-default]="isDisabled"
        (blur)="onBlur()"
      />

      <!-- @if (tooltipHintIsNeeded) {
      <svg-icon
        class="absolute left-[10px] top-[50%] translate-y-[-50%] text-text-100 secondary-text-500"
        key="info-24"
        size="lg"
        [appTooltip]="hintMessage"
      ></svg-icon>
      } -->
    </div>
    <div class="absolute h-full top-0 left-0 flex items-center pointer-events-none text-action-primary pl-3">
      <svg-icon key="calendar-24" size="24" (click)="allowFreeText && picker.open()" />
    </div>
    <div class="absolute h-full top-0 right-0 flex items-center pointer-events-none text-action-primary pr-3">
      <svg-icon key="chevron-down-16" size="16" (click)="allowFreeText && picker.open()"></svg-icon>
    </div>
    @if (!errorInFlow()) {
      <div class="absolute top-[calc(100%_+_4px)] left-0 w-full text-xs font-medium text-status-error">
        {{ error() ?? '' }}
      </div>
    }
  </div>
  @if (errorInFlow() && error(); as error) {
    <div class="mt-1 w-full text-xs font-medium text-status-error">{{ error }}</div>
  }
  <!-- <span *ngIf="hintMessage && !tooltipHint" class="font-normal text-x-small text-text-700 pt-1">{{ hintMessage }}</span>
  <span *ngIf="errorMessage" class="font-normal text-x-small text-error-500 pt-1">{{ errorMessage }}</span>
  <span *ngIf="warningMessage" class="font-normal text-x-small text-warning-600 pt-1">{{ warningMessage }}</span> -->
</div>
